import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Text } from '@ds'
import { GalaxyButton } from '@shared'

import styles from './Shop.module.scss'

export const Shop: FC = () => {
  const navigate = useNavigate()

  const handleDispatcherClick = useCallback(() => {
    navigate('/shop')
  }, [navigate])

  return (
    <div className={styles.container}>
      <GalaxyButton
        withGlow={false}
        className={styles.button}
        onClick={handleDispatcherClick}
      >
        <Text type="body" center>
          Go to dispatcher
        </Text>
      </GalaxyButton>
      <Text type="body-4" center className={styles.notice}>
        Remember, You can upgrade a lot of things with the dispatcher
      </Text>
    </div>
  )
}
